export default function showIntroOverlay() {
    const overlay = document.getElementById('introOverlay')
    const page1 = document.getElementById('page1')
    const page2 = document.getElementById('page2')
    const nextBtn = document.getElementById('nextBtn')
    const prevBtn = document.getElementById('prevBtn')
    const closeBtn = document.getElementById('closeBtn')

    // Start mit Seite 1
    overlay.classList.remove('hidden')
    page1.classList.remove('hidden')
    page2.classList.add('hidden')

    nextBtn.onclick = () => {
        page1.classList.add('hidden')
        page2.classList.remove('hidden')
    }

    prevBtn.onclick = () => {
        page2.classList.add('hidden')
        page1.classList.remove('hidden')
    }

    closeBtn.onclick = () => {
        overlay.classList.add('hidden')
    }
}
